module.exports = __webpack_public_path__ + "img/simple-marker.b165a69b.svg";